"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Openlayers-Wrapper des WFS-Providers.
 *
 * @class
 * @extents gc.gis.GCWrappable
 * @memberof gc.gis
 * @author Anton Popov <a.popov@brain-scc.de>
 */
gc.gis.OLWFSProvider = function( options )
{
	gc.gis.map.GCAbstractWFSProvider.call( this, options );
};
gc.gis.OLWFSProvider.prototype = Object.create( gc.gis.map.GCAbstractWFSProvider.prototype );

/**
 *
 */
gc.gis.OLWFSProvider.prototype.loadWFS = function( config )
{
	gc.gis.iface.loadLayer( config );
};

/**
 * @param {gc.gis.layer.GCVectorLayer} layer Vektor-Layer-Instanz
 * @return {jQuery} jQuery-Element
 */
gc.gis.OLWFSProvider.prototype.getLegendGraphic = function( layer )
{
	gc.gis.assert.isInstance( layer, gc.gis.layer.GCVectorLayer );

	const div_legend = jQuery('<div>', {
		'class': 'legend-graphic'
	});

	const ol_layer = layer.getImpl();
	if(ol_layer)
	{
		let styles = ol_layer.getStyle();
		if (typeof styles === 'function')
		{
			styles = styles();
		}
		if (!Array.isArray(styles))
		{
			styles = [styles];
		}

		if(styles.length > 0)
		{
			for(let i=0; i<styles.length; i++)
			{
				const fill = styles[i].getFill(),
					stroke = styles[i].getStroke(),
					fillColor = new gc.gis.style.GCColor(fill.getColor()),
					strokeColor = new gc.gis.style.GCColor(stroke.getColor());

				const div_style = jQuery('<div>', {
					css: {
						'display': 'block',
						'width': '1.5em',
						'height': '1.5em',
						'background-color': (fill ? fillColor.toString() : 'transparent'),
						'border-style': 'solid',
						'border-width': (stroke ? stroke.getWidth() +'px' : '0'),
						'border-color': (stroke ? strokeColor.toString() : 'transparent')
					}
				});
				div_legend.append( div_style );
			}
		}
		else
		{
			div_legend.append( jQuery('<em>', {
				text: 'Keine Style-Informationen gefunden.'
			}) );
		}
	}
	else
	{
		div_legend.append( jQuery('<em>', {
			text: 'Layer nicht geladen.'
		}) );
	}

	return div_legend;
};

/**
 * @inheritDoc
 */
gc.gis.OLWFSProvider.prototype.getGetFeatureUrl = function(layer)
{
	gc.gis.assert.isInstance(layer, gc.gis.layer.GCVectorLayer);

	// TODO ggf. weitere Parameter z.B. FILTER bei Bedarf unterstützen
	const params = {
		SERVICE: 'WFS',
		VERSION: layer.getVersion() || '2.0.0',
		REQUEST: 'GetFeature',
		TYPENAME: layer.getName()
	};

	return gc.gis.GCUrl.buildUrl(layer.getUrl(), params);
};
